import { StrictMode } from 'react'

import { ThemeProvider } from '@vr/ds-react'
import { createRoot } from 'react-dom/client'

import App from './App.tsx'

const rootElement = document.getElementById('root')
if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <ThemeProvider emissor='VRPAT'>
        <App />
      </ThemeProvider>
    </StrictMode>
  )
} else {
  throw new Error("Root element with id 'root' not found.")
}
